import React, { useState, useEffect } from 'react'
import { toast } from 'react-toastify'
import * as yup from 'yup'
import { useFormik } from 'formik'
import { InboxType } from '../../../../server/models/Inbox'
import { InboxMemberType } from '../../../../server/models/InboxMember'
import { Modal, ModalActions } from '../../../components/Modal'
import { createInbox } from '../../../requests/inboxes'
import { handleError } from '../../../errors/handleError'
import { Input } from '../../../components/Inputs/Input'
import { CreatedInboxSuccessModal } from '../CreatedInboxSuccessModal'
import { useAuth } from '../../../contexts/useAuthUser'

const placeholderIdeas = [
  'E-commerce Trends',
  'LinkedIn Strategies',
  'B2B Marketing',
  'SaaS Growth',
  'D2C Insights',
  'Retail Analytics',
  'Facebook Ads',
  'Instagram Campaigns',
  'Tech Industry News',
  'Healthcare Content',
  'Financial Services',
  'Content for Startups',
  'Automotive Branding',
  'Consumer Electronics',
  'FMCG Marketing',
  'YouTube Channels',
  'Amazon Marketplace',
  'Influencer Outreach',
  'AI in Marketing',
  'Sustainability Efforts'
]
let placeholderIndex = 0

type Props = {
    onInboxJoined: (newInboxMembership: InboxMemberType) => void
}

export const CreateInboxButton: React.FC<Props> = ({
  onInboxJoined
}) => {
  const { authUser } = useAuth()
  const [formModalShowing, setFormModalShowing] = useState(false)
  const [placeholder, setPlaceholder] = useState(placeholderIdeas[0])
  const [completedModalShowing, setCompletedModalShowing] = useState(false)
  const [createdInbox, setCreatedInbox] = useState<InboxType>()

  const formik = useFormik({
    validationSchema: yup.object({
      name: yup.string().required()
    }),
    initialValues: {
      name: ''
    },
    onSubmit: async (values) => {
      try {
        const res = await createInbox(values)
        setCreatedInbox(res.data)

        onInboxJoined({
          inbox: res.data,
          userId: authUser._id,
          role: 'owner'
        })

        toast.success('😎 Folder successfully created.')

        setFormModalShowing(false)
        setCompletedModalShowing(true)
      } catch (err) {
        handleError(err, 'Something went wrong creating this folder. Please try again later.')
      }
    }
  })

  const closeModal = () => {
    setFormModalShowing(false)
    setCompletedModalShowing(false)
    formik.resetForm()
  }

  const showFormModal = () => {
    setFormModalShowing(true)
  }

  useEffect(() => {
    if (formik.touched.name) {
      return
    }

    setInterval(() => {
      placeholderIndex = placeholderIndex + 1
      setPlaceholder(placeholderIdeas[placeholderIndex % placeholderIdeas.length])
    }, 3000)
  }, [formik.touched.name])

  if (!authUser?.superAdmin) {
    return null
  }

  return (
    <>
      <Modal isOpen={formModalShowing} onRequestClose={closeModal}>
        <form onSubmit={formik.handleSubmit}>
          <h2>Name your folder</h2>
          <p>
                      What type of content will you be curating in this folder?
          </p>
          <Input
            name="name"
            type="text"
            formik={formik}
            placeholder={placeholder}
            label="Folder Name"
          />
          <ModalActions
            onCancel={closeModal}
            loading={formik.isSubmitting}
            submitText="Submit"
            submit
          />
        </form>
      </Modal>

      <CreatedInboxSuccessModal
        isOpen={completedModalShowing}
        onRequestClose={closeModal}
        createdInbox={createdInbox}
        loading={formik.isSubmitting}
      />

      <button className="primary plausible-event-name=ClickCreateInbox" onClick={showFormModal}>
                Create Folder
      </button>
    </>
  )
}
